import React from "react";
import { Link } from 'react-router-dom';

import { Navigation, Pagination } from "swiper/modules";

export default function Banner() {
  return (
    <div className="block-row bg-brand pb-1x pt-1x banner-block">

    <div className="container">

        <div className="banner-item">
          <div className="banner flex">
            <div className="caption-area">
              <div className="container">
                <div className="price">
                  <img src="/images/star-white.svg" alt="star icon" />
                  <p>Current Price: $0.004</p>
                  <img src="/images/star-white.svg" alt="star icon" />
                </div>
                <h1>
                  The Only Crypto That Pays You To Use Your Phone
                </h1>
                <div className="img-area mob-view">
                  <figure>
                    <img src="/images/banner.svg" alt="Banner" />
                  </figure>
                </div>
                <div className="captions">
                  <p>Earn RZTO tokens with every call & mobile plan renewal through our partnership with Rizz Wireless.</p>
                  <span>Real telecom utility × Real partnerships × Real profits</span>
                  <div className="caption-bottom">
                    <p>While 99% of "utility" tokens sit useless in wallets, RZTO powers real telecom services through Rizz Wireless (FCC-licensed US operator). Your tokens work from Day 1.</p>
                    <ul>
                      <li className="flex">
                        <img src="/images/star-white.svg" alt="star icon" />
                        <span>Earn up to 100 RZTO monthly just for mobile plan renewal</span>
                      </li>
                      <li className="flex">
                        <img src="/images/star-white.svg" alt="star icon" />
                        <span>Get 1 RZTO per call minute + 5 RZTO per unused GB</span>
                      </li>
                      <li className="flex">
                        <img src="/images/star-white.svg" alt="star icon" />
                        <span>Redeem for travel discounts via zoyili.com partnership</span>
                      </li>
                      <li className="flex">
                        <img src="/images/star-white.svg" alt="star icon" />
                        <span>Use for fitness & lifestyle vouchers (Nike, Adidas, gym memberships)</span>
                      </li>
                      <li className="flex">
                        <img src="/images/star-white.svg" alt="star icon" />
                        <span>Stake for 8-10% APY paid in mobile data</span>
                      </li>
                      <li className="flex">
                        <img src="/images/star-white.svg" alt="star icon" />
                        <span>Auto-burn reduces supply with every transaction</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="btn-group">
                  <Link to="/token/quick-buy" className="btn btn-shadow token-data btn-lg" data-note="*Token sale offer is not for US Citizens or US Residents">QUICK PURCHASE - $0.004</Link>
                </div>
              </div>
            </div>
            <div className="img-area">
              <figure>
                <img src="/images/banner.svg" alt="Banner" />
              </figure>
            </div>
          </div>
        </div>
    </div>
    </div>
  );
}
